import axios from "@/libs/api.request";
export function getVlogType() {
    return axios.request({
        url: "VlogType/getVlogTypeList",
        method: "get",
    })
}
export function getVlogTypeMain(params) {
    return axios.request({
        url: "VlogType/getVlogTypeMain",
        method: "get",
        params:params,
    })
}
export function getVlogTypeNum() {
    return axios.request({
        url: "VlogType/getVlogTypeNum",
        method: "get",
    })
}
export function submitVlogType(params) {
    return axios.request({
        url: "VlogType/setVlogTypeTree",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}

export function getDataInfo(params) {
    return axios.request({
        url: "VLogInfo/getNewsList",
        method: "get",
        params:params,
    })
}
export function getVlogData(params) {
    return axios.request({
        url: "VLogInfo/getVlogAllList",
        method: "get",
        params:params,
    })
}
export function getVlogNoContent(params) {
    return axios.request({
        url: "VLogInfo/getVlogNoContent",
        method: "get",
        params:params,
    })
}
export function submitDataInfo(params) {
    return axios.request({
        url: "VLogInfo/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}